module.exports = __webpack_public_path__ + "img/esim-install-orange.086d4cc3.svg";